import React from "react";
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import {Route, Switch} from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";
import configureStore, { history } from './appRedux/store';
import App from "./containers/App/index";

// PubNub imports
import PubNub from "pubnub";
import { PubNubProvider } from "pubnub-react";

// Initialize PubNub client
const pubnub = new PubNub({
  publishKey: process.env.REACT_APP_PUBNUB_PUBLISH_KEY,
  subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY,
  uuid: "admin-portal-1758272512676", // unique ID for this user
});

const store = configureStore(undefined);

const NextApp = () =>
  <Provider store={store}>
    <PubNubProvider client={pubnub}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App}/>
        </Switch>
      </ConnectedRouter>
    </PubNubProvider>
  </Provider>;


export default NextApp;
